import { Controller } from 'stimulus'

// Floating "Ask AI" launcher: opens the chat drawer over the current page.
// The chat itself is the React AiChatApp mounted inside the drawer.
export default class extends Controller {
  open() {
    this.element.classList.add('ai-launcher-open')
  }

  close() {
    this.element.classList.remove('ai-launcher-open')
  }
}
